import {
	DetailLabel,
	DetailTitle,
} from '@dealstack/frontend/shared/components/EditableInfoField/styled.tsx';
import { Flex, Text } from '@mantine/core';
import type { DetailEditableFieldProps } from './EditableInfoField.types';

export const EditableInfoField = ({
	formInput,
	editMode,
	label,
	data,
	customValueElement,
	valueDataTestId,
	justifyContent = 'flex-start',
	allowOverflow,
	style = {},
}: DetailEditableFieldProps) => {
	return (
		<Flex
			direction="column"
			justify={justifyContent}
			style={{ overflow: allowOverflow ? 'visible' : 'hidden', ...style }}
		>
			{editMode ? (
				<>
					<DetailLabel>{label}</DetailLabel>
					{formInput}
				</>
			) : (
				<>
					<DetailTitle>{label}</DetailTitle>
					{customValueElement ?? (
						<Text fz={18} data-testid={valueDataTestId} fw={400} c="dark.8" truncate>
							{data}
						</Text>
					)}
				</>
			)}
		</Flex>
	);
};
